import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import promiseMiddleware from 'redux-promise';
import { MuiThemeProvider } from '@material-ui/core/styles';
import App from './App';
import './index.css';
import './react-select.css';
import rootReducer from './ducks';
import adminTheme from './theme';

// Подавляем предупреждения React о нестандартных props в DOM и устаревших lifecycle методах
// Эти предупреждения идут из старых версий библиотек (Material-UI, react-router-dom, glamorous)
const originalError = console.error;
const originalWarn = console.warn;

console.error = (...args) => {
  // Проверяем все аргументы, так как предупреждение может быть в любом из них
  const message = args.map(arg => typeof arg === 'string' ? arg : '').join(' ');
  
  if (
    message.includes('React does not recognize') ||
    message.includes('Received `false` for a non-boolean attribute') ||
    message.includes('componentWillMount') ||
    message.includes('componentWillReceiveProps') ||
    message.includes('indicator') ||
    message.includes('fullWidth') ||
    message.includes('textColor')
  ) {
    // Подавляем эти предупреждения
    return;
  }
  originalError.apply(console, args);
};

console.warn = (...args) => {
  // Проверяем все аргументы, так как предупреждение может быть в любом из них
  const message = args.map(arg => typeof arg === 'string' ? arg : '').join(' ');
  
  if (
    message.includes('componentWillMount') ||
    message.includes('componentWillReceiveProps') ||
    message.includes('React does not recognize') ||
    message.includes('Received `false` for a non-boolean attribute') ||
    message.includes('indicator') ||
    message.includes('fullWidth') ||
    message.includes('textColor')
  ) {
    // Подавляем эти предупреждения
    return;
  }
  originalWarn.apply(console, args);
};

const middlewares = [promiseMiddleware];

// Безопасная проверка NODE_ENV
const isDevelopment = typeof process !== 'undefined' && 
  process.env && 
  process.env.NODE_ENV === 'development';

if (isDevelopment) {
  const { logger } = require('redux-logger');

  middlewares.push(logger);
}

const store = createStore(
  rootReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(), // eslint-disable-line
  applyMiddleware(...middlewares)
);

const start = (
  <MuiThemeProvider theme={adminTheme}>
    <Provider store={store}>
      <App />
    </Provider>
  </MuiThemeProvider>
);

ReactDOM.render(start, document.getElementById('root'));
